import React, { useEffect, useState } from "react";
import adminApi from "../../shared/api/AxiosAdmin";

const API_BASE = process.env.REACT_APP_API_BASE_URL as string;
const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "").replace(/\/$/, "");


interface MediaEntry {
  url?: string;
  videoId?: string;
  posterUrl?: string;
  isHls?: boolean;
}

interface ReportItem {
  _id: string;
  reason: string;
  details: string;
  createdAt: string;

  reporter?: {
    _id: string;
    profilename: string;
    picture?: string;
  };

  post?: {
    _id: string;
    createdAt: string;
    user?: {
      _id: string;
      profilename: string;
      picture?: string;
    };
    media: MediaEntry[];
  };
}

export default function AdminPostReport() {
  const [reports, setReports] = useState<ReportItem[]>([]);
  const [loading, setLoading] = useState(true);

  const loadReports = async () => {
    try {
      setLoading(true);

     const res = await adminApi.get("/admin/media/reports");
     const data = res.data;
      setReports(data.items || []);

    } catch (err) {
      console.error("Failed to load reports", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReports();
  }, []);

  const resolveReport = async (reportId: string) => {
    await adminApi.post(`/admin/media/reports/${reportId}/resolve`);

    loadReports();
  };

  const deletePost = async (postId: string) => {
    if (!window.confirm("Delete this post?")) return;
    await adminApi.delete(`/admin/media/${postId}`);


    loadReports();
  };

  const blockPost = async (postId: string) => {
    const reason = prompt("Reason for blocking post?") || "";

    await adminApi.post(`/admin/media/admin/${postId}/block`, { reason });

    loadReports();
  };

  if (loading) {
    return (
      <div style={{ padding: 40, color: "#aaa" }}>
        Loading reports...
      </div>
    );
  }

  return (
    <div
      style={{
        padding: 30,
        color: "#ddd",
        maxWidth: 1100,
        margin: "0 auto"
      }}
    >
      <h2 style={{ marginBottom: 20 }}>🚩 Reported Posts</h2>

      {reports.length === 0 && (
        <div>No reports 🎉</div>
      )}

      {reports.map((r) => {
        const post = r.post;

        return (
          <div
            key={r._id}
            style={{
              border: "1px solid #333",
              borderRadius: 10,
              padding: 16,
              marginBottom: 20,
              background: "#111"
            }}
          >
            {/* REPORT INFO */}

            <div style={{ marginBottom: 10 }}>
              <b>Reason:</b> {r.reason}
            </div>

            {r.details && (
              <div style={{ marginBottom: 10 }}>
                <b>Details:</b> {r.details}
              </div>
            )}

            <div style={{ marginBottom: 10 }}>
              <b>Reported by:</b>{" "}
              {r.reporter?.profilename || "Unknown"}
            </div>

            <div style={{ marginBottom: 10 }}>
              <b>Date:</b>{" "}
              {new Date(r.createdAt).toLocaleString()}
            </div>

            {/* POST INFO */}

            {post && (
              <>
                <div style={{ marginBottom: 10 }}>
                  <b>Author:</b>{" "}
                  {post.user?.profilename || "Unknown"}
                </div>

                {/* MEDIA PREVIEW */}

                <div
                  style={{
                    display: "flex",
                    gap: 10,
                    overflowX: "auto",
                    marginBottom: 15
                  }}
                >
                  {post.media.map((m, i) => {
                    if (m.isHls && m.videoId) {
                      return (
                        <video
                          key={i}
                         src={`${API_ORIGIN}/hls/playlist/${m.videoId}`}
                          poster={m.posterUrl}
                          controls
                          style={{
                            width: 200,
                            borderRadius: 6
                          }}
                        />
                      );
                    }

                    if (m.url) {
                      return (
                        <img
                          key={i}
                          src={m.url}
                          alt=""
                          style={{
                            width: 200,
                            borderRadius: 6
                          }}
                        />
                      );
                    }

                    return null;
                  })}
                </div>

                {/* ACTION BUTTONS */}

                <div
                  style={{
                    display: "flex",
                    gap: 10,
                    flexWrap: "wrap"
                  }}
                >
                  <button
                    onClick={() => deletePost(post._id)}
                    style={btnDanger}
                  >
                    🗑 Delete Post
                  </button>

                  <button
                    onClick={() => blockPost(post._id)}
                    style={btnWarning}
                  >
                    ⛔ Block Post
                  </button>

                  <button
                    onClick={() => resolveReport(r._id)}
                    style={btnNeutral}
                  >
                    ✔ Resolve Report
                  </button>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}

const btnDanger: React.CSSProperties = {
  padding: "8px 14px",
  borderRadius: 6,
  border: "none",
  background: "#b91c1c",
  color: "#fff",
  cursor: "pointer"
};

const btnWarning: React.CSSProperties = {
  padding: "8px 14px",
  borderRadius: 6,
  border: "none",
  background: "#b45309",
  color: "#fff",
  cursor: "pointer"
};

const btnNeutral: React.CSSProperties = {
  padding: "8px 14px",
  borderRadius: 6,
  border: "none",
  background: "#333",
  color: "#fff",
  cursor: "pointer"
};